
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skillbuilders/[...slug]",
      function () {
        return require("private-next-pages/skillbuilders/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skillbuilders/[...slug]"])
      });
    }
  